import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../css/teacher_list.css';
import ApiService from '../../../../services/api';
import Add from '../../../../media/add.png';
import Edit from '../../../../media/edit.png';
import Delete from '../../../../media/delete.png';
import Organization from '../../../../media/organization.png';
import Search from '../../../../media/search.png';
import { toast } from "react-toastify";
import { confirmToast } from '../../../app/components/confirmToast';

const OrganizationList = () => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const res = await ApiService.getOrganizations();
        setOrganizations(res);
      } catch (err) {
        console.error('Errore:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrganizations();
  }, []);

  const normalizedSearch = search.trim().toLowerCase();

 const filteredOrganizations = organizations.filter(o => {
  const organizationName = `${o.name}`.toLowerCase();
  return organizationName.includes(normalizedSearch);
});

  const handleDelete = async (slug) => {
   
    confirmToast({
            message: `Sei sicuro di voler eliminare questo Ente?`,
            type: "error",
            confirmText: "Elimina",
             onConfirm: async () => {
              try {
                await ApiService.deleteOrganization(slug);
                setOrganizations(prev => prev.filter(t => t.slug !== slug));
                toast.success(`Ente eliminato con successo.`);
              } catch (err) {
                toast.error("Errore durante l'eliminazione");
                      
              }
            },
          });
  };

  return (
    <div className="teacher-list-container">
      <div className="teacher-list-header" style={{marginBottom:'50px'}}>
        <h2><img src={Organization} alt="" className="section-image" /> Enti</h2>
        <div className="search-zone">
          <img src={Search} alt="Cerca" className="search-image" />
          <input
          className='search-area'
          type="text"
          placeholder="Cerca Ente..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <button
          className="create-button"
          onClick={() => navigate('crea')}
        >
          <img src={Add} alt="Aggiungi" className="button-image" />
        </button>
      </div>

      {loading ? (
        <p>Caricamento...</p>
      ) : organizations.length === 0 ? (
        <p>Nessun Ente disponibile</p>
      ) : (
        <ul className="teacher-list">
          {filteredOrganizations.map((organization) => (
            <li key={organization.id} className="teacher-card">
              <div className="teacher-info">
                <strong>{organization.name}</strong>
              </div>
              <div className="teacher-actions">
                <button
                  className="create-button"
                  onClick={() => navigate(`modifica/${organization.slug}`)}
                >
                  <img src={Edit} alt="Modifica" className="button-image" />
                </button>
                <button
                  className="create-button"
                  onClick={() => handleDelete(organization.slug)}
                >
                  <img src={Delete} alt="Elimina" className="button-image" />
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default OrganizationList;
